<template>
    <div class="maze">
        <div class="row" v-for="y in maze.height">
            <div 
                class="col" 
                v-for="x in maze.width"
                v-bind:class="{wall: maze.cells[y][x].isWall}"
                ><div 
                    v-if="x === maze.arrow.x && y === maze.arrow.y"
                    v-bind:class="{
                        'rotate-up': maze.arrow.direction === 'up', 
                        'rotate-left': maze.arrow.direction === 'left', 
                        'rotate-right': maze.arrow.direction === 'right', 
                        'rotate-down': maze.arrow.direction === 'down'
                    }"
                    >&#10148;</div>
                    <div v-if="x === maze.finish.x && y === maze.finish.y">&#9872;</div>
                    <div v-if="(x !== maze.arrow.x || y !== maze.arrow.y) && (x !== maze.finish.x || y !== maze.finish.y)">&nbsp;</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Maze',
        props: ['id', 'maze'],
        components: {
        },
        created () {
        },
        methods: {
        },
        data () {
            return {
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .maze, .row, .col {
        padding: 0px;
        margin: 0px;
    }
    .maze .row {
        margin-bottom: -1px;
    }
    .maze .row .col {
        display: inline-block;
        min-width: 30px;
        min-height: 30px;
        border: 1px solid #DDD;
        background-color: #F0F0F0;
        padding: 5px;
        margin-right: -1px;
        font-size: 26px;
        color: #622;
    }
    .maze .row .col.wall {
        background-color: #888;
    }
    .rotate-right {
    }
    .rotate-up {
        -moz-transform: rotate(-90deg);
        -ms-transform: rotate(-90deg);
        -o-transform: rotate(-90deg);
        -webkit-transform: rotate(-90deg);
        transform: rotate(-90deg);
    }
    .rotate-down {
        -moz-transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        -o-transform: rotate(90deg);
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
    }
    .rotate-left {
        -moz-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        -o-transform: rotate(180deg);
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);

    }
</style>


// WEBPACK FOOTER //
// src/Components/MazeGame/Maze.vue